/**
 * COLOR SWATCHES (CDROX)
 * Custom element para o seletor de cor por metafield (produtos-irmaos separados).
 * Ao clicar numa bolinha, troca imagem/titulo/link/alvo-do-add-to-cart do card NO LUGAR,
 * sem reload e sem requisicao de rede (os dados ja estao em data-attributes = instantaneo).
 * Robusto: cada acesso tem guard; se nao achar o card, deixa o <a> nativo navegar (fallback).
 * Leve: um unico listener por elemento (event delegation) + preload da imagem no hover.
 */
(function () {
  if (window.customElements && customElements.get('color-swatches')) return;

  class ColorSwatches extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', this._onClick.bind(this));
      // preload da imagem-alvo quando o mouse chega na bolinha (so 1x por bolinha)
      this.addEventListener('pointerenter', this._onHover.bind(this), true);
    }

    _onHover(e) {
      const dot = e.target.closest ? e.target.closest('.color-swatch-dot') : null;
      if (!dot || dot._preloaded || !dot.dataset.image) return;
      dot._preloaded = true;
      try {
        const im = new Image();
        if (dot.dataset.srcset) im.srcset = dot.dataset.srcset;
        im.src = dot.dataset.image;
      } catch (err) { /* silencioso */ }
    }

    _onClick(e) {
      const dot = e.target.closest ? e.target.closest('.color-swatch-dot') : null;
      if (!dot) return;

      const card = this.closest('product-card');
      if (!card) return; // sem card -> deixa o link nativo levar pro produto (fallback gracioso)

      e.preventDefault();
      const d = dot.dataset;

      // 1) imagem principal (crossfade leve, sem flash)
      const img = card.querySelector('.product-card__image--primary');
      this._swapImage(img, d.image, d.srcset);

      // 2) esconde a imagem secundaria (a que aparece no hover) pra nao mostrar a cor antiga
      const secondary = card.querySelector('.product-card__image--secondary');
      if (secondary) secondary.style.display = 'none';

      // 3) titulo (texto + link)
      const title = card.querySelector('.product-title');
      if (title) {
        if (d.title) title.textContent = d.title;
        if (d.url) title.setAttribute('href', d.url);
      }

      // 4) link do card clicavel (a midia)
      const media = card.querySelector('.product-card__media');
      if (media && d.url) media.setAttribute('href', d.url);

      // 5) alvo do add-to-cart (produto de 1 variante = input hidden; multi-variante = modal)
      const idInput = card.querySelector('.product-card__quick-buy [name="id"]');
      if (idInput && d.variantId) idInput.value = d.variantId;
      const modal = card.querySelector('quick-buy-modal');
      if (modal && d.url) modal.setAttribute('product-url', d.url);

      // 6) estado selecionado
      const dots = this.querySelectorAll('.color-swatch-dot');
      for (let i = 0; i < dots.length; i++) dots[i].classList.toggle('is-selected', dots[i] === dot);
    }

    _swapImage(img, src, srcset) {
      // crossfade leve: decodifica a nova imagem (ja veio pre-carregada no hover) ANTES de trocar o src,
      // entao o swap pinta sem flash; um fade curto de opacidade da a transicao. Sem lib, sem rede extra
      // (a decode reusa o cache do preload do hover). Fallback: se algo falhar, revela na hora.
      if (!img || !src) return;
      img.style.transition = 'opacity .2s ease';
      const reveal = function () { img.style.opacity = '1'; };
      const commit = function () {
        if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
        img.src = src;
        requestAnimationFrame(function () { requestAnimationFrame(reveal); });
      };
      img.style.opacity = '0.3';
      try {
        const pre = new Image();
        if (srcset) pre.srcset = srcset;
        pre.src = src;
        if (pre.decode) { pre.decode().then(commit).catch(commit); }
        else if (pre.complete) { commit(); }
        else { pre.onload = commit; pre.onerror = commit; }
      } catch (err) { commit(); }
      setTimeout(reveal, 450); // seguranca: nunca prende a imagem em opacidade baixa
    }
  }

  customElements.define('color-swatches', ColorSwatches);
})();
